/**
 * CampListReq 类型和 Schema 定义
 *
 * ⚠️ 注意: 此文件由脚本自动生成，请勿手动修改
 * 如需更新，请运行代码生成脚本
 */
import type { SchemaDefinition } from './_schema'

/**
 * CampListReq
 */
export interface CampListReq {
  /** 搜索关键词 */
  q?: string
  /** 是否删除 */
  deleted?: boolean
  /** 页码 */
  page?: number
  /** 每页数量 */
  page_size?: number
  /** 排序字段 */
  order_by?: string
  /** 排序方向 */
  order?: string
  /** 创建时间范围 (start,end) */
  created_at__range?: any
  /** 更新时间范围 (start,end) */
  updated_at__range?: any
  /** 更新时间距今 (7d/1h/30m) */
  updated_at__since?: any
  /** 禁用状态 */
  disabled?: boolean
  /** ID列表 */
  id__in?: string[]
  /** 群主用户ID */
  owner_id?: any
  /** 加入策略 */
  join_policy?: string
  /** 段位层次 */
  rank_tier?: number
  /** 最小成员数 */
  member_count__gte?: number
  /** 最大成员数 */
  member_count__lte?: number
  /** 最小段位 */
  rank_tier__gte?: number
  /** 最大段位 */
  rank_tier__lte?: number
  /** 名称包含 */
  name__like?: string
}

/**
 * CampListReq Schema
 */
export const CampListReqSchema: SchemaDefinition = {
  properties: {
    q: {
      description: '搜索关键词',
      format: 'string',
      type: 'string',
      label: '搜索关键词',
    },
    deleted: {
      description: '是否删除',
      format: '*bool',
      type: 'boolean',
      label: '是否删除',
    },
    page: {
      description: '页码',
      format: 'int',
      type: 'integer',
      label: '页码',
    },
    page_size: {
      description: '每页数量',
      format: 'int',
      type: 'integer',
      label: '每页数量',
    },
    order_by: {
      description: '排序字段',
      format: 'string',
      type: 'string',
      label: '排序字段',
    },
    order: {
      description: '排序方向',
      format: 'string',
      type: 'string',
      label: '排序方向',
    },
    created_at__range: {
      description: '创建时间范围 (start,end)',
      format: '[]string',
      type: 'datetime',
      label: '创建时间范围',
    },
    updated_at__range: {
      description: '更新时间范围 (start,end)',
      format: '[]string',
      type: 'datetime',
      label: '更新时间范围',
    },
    updated_at__since: {
      description: '更新时间距今 (7d/1h/30m)',
      format: '[]string',
      type: 'datetime',
      label: '更新时间距今',
    },
    disabled: {
      description: '禁用状态',
      format: '*bool',
      type: 'boolean',
      label: '禁用状态',
    },
    id__in: {
      description: 'ID列表',
      format: '[]string',
      items: {
        format: 'string',
        type: 'string',
      },
      type: 'array',
      label: 'ID列表',
    },
    owner_id: {
      description: '群主用户ID',
      format: 'string',
      type: 'user',
      label: '群主用户ID',
    },
    join_policy: {
      description: '加入策略',
      format: '*cons.CampJoinPolicy',
      type: 'string',
      label: '加入策略',
    },
    rank_tier: {
      description: '段位层次',
      format: '*cons.GroupRankTier',
      type: 'integer',
      label: '段位层次',
    },
    member_count__gte: {
      description: '最小成员数',
      format: '*int',
      type: 'integer',
      label: '最小成员数',
    },
    member_count__lte: {
      description: '最大成员数',
      format: '*int',
      type: 'integer',
      label: '最大成员数',
    },
    rank_tier__gte: {
      description: '最小段位',
      format: '*int',
      type: 'integer',
      label: '最小段位',
    },
    rank_tier__lte: {
      description: '最大段位',
      format: '*int',
      type: 'integer',
      label: '最大段位',
    },
    name__like: {
      description: '名称包含',
      format: 'string',
      type: 'string',
      label: '名称包含',
    },
  },
  type: 'object',
}
